import { redirect } from "@/router";

export const Loader = () => redirect("/billing/dues-management/manage-products/annual-national-rates");
